const {
  Modal,
// eslint-disable-next-line no-undef
} = jesuitsFramework;

export default function initSearchModal() {
  const buttons = document.querySelectorAll('.js-search-modal-trigger');
  if (!buttons) return;

  const modalContent = document.querySelector('.js-search-modal');
  if (!modalContent) return;

  const siteHeader = document.querySelector('.main-header');

  Array.prototype.slice.call(buttons).forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      if (modalContent) {
        new Modal().open(modalContent);
        if (siteHeader) {
          const overlay = document.querySelector('.overlay');
          if (overlay) {
            overlay.style.backgroundColor = 'transparent';
            overlay.style.paddingTop = `${siteHeader.getBoundingClientRect().top + siteHeader.getBoundingClientRect().height}px`;
          }
        }
        modalContent.querySelector('input').focus();
      }
    });
  });
}
